// api/register/useCompleteRegister.ts

import { useMutation } from "@tanstack/react-query";

import { Methods } from "../../../Constants/ApiConstants";
import { EndPoints } from "../../../Constants/endpoints";
import {
  GeneralResponse,
  RegisterResponse,
} from "../../../interface/GeneralResponse";
import { CompleteRegisterRequest } from "../../../interface/IRegister";
import { useToast } from "../../../Services/ToastContext";
import Api from "../../generalApi/Api";
import { useTranslation } from "react-i18next";
const useCompleteRegister = () => {
  const { showToast } = useToast();
  
  const {t} = useTranslation()
  return useMutation({
    mutationFn: async (
      data: CompleteRegisterRequest,
    ): Promise<GeneralResponse<RegisterResponse>> => {
      if (!data || Object.keys(data).length === 0) {
        throw new Error("Invalid data");
      }

      const values = new FormData();

      if (data.AccountTypeId) {
        values.append("AccountTypeId", data.AccountTypeId);
      }
      if (data.SpecialityId) {
        values.append("SpecialityId", data.SpecialityId);
      }
      if (data.File) {
        values.append("File", data.File);
      }

      const response = await Api<FormData, GeneralResponse<RegisterResponse>>({
        method: Methods.POST,
        endpoint: EndPoints.CompleteRegister,
        body: values,
      });

      if (!response.Status) {
        throw new Error(
          response.ErrorMessage || "Registration completion failed",
        );
      }

      return response;
    },
    onSuccess: (response) => {
      if (response && response.Status && response.Data) {
        // Dispatching user details is already handled in the component's `onSuccess`
      } else {
      }
    },
    onError: (error: any) => {
      showToast(error.message || t("error_occurred"), "error");
    },
  });
};

export default useCompleteRegister;
